var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AnalyticsManager, composeTransforms, createPluginDataGo, createPluginGA, createPluginYM, defaultDataGoTransform, defaultDataGoUserContextTransform, } from "@s7/analytics";
import { getCookie } from "@s7/cookies";
var createAppFlowContext = function () {
    var mainPaths = ["/", "/ru/", "/en/", "/zh/"];
    if (mainPaths.indexOf(window.location.pathname) > -1) {
        return "main";
    }
    return "page";
};
var flow = createAppFlowContext();
var DATAGO_ID = process.env.REACT_APP_DATAGO_ID;
export var analytics = AnalyticsManager({
    transform: function (eventName, payload) { return (__assign(__assign({ application: "portal", event_name: eventName }, (flow && { flow: flow })), payload)); },
    plugins: [
        createPluginGA({
            initialize: {
                scriptSource: process.env.REACT_APP_GA_SCRIPT_SOURCE,
                containerId: process.env.REACT_APP_GA_ID,
            },
        }),
        createPluginYM({
            initialize: function () { return ({
                counterId: process.env.REACT_APP_YANDEX_ID,
                instanceKey: "ym",
                status: function () { return true; },
            }); },
            transform: function (eventName, payload) { return (__assign({ user_id: getCookie(process.env.REACT_APP_ANALYTICS_USER_IDENTITY_COOKIE_NAME) }, payload)); },
        }),
        DATAGO_ID &&
            createPluginDataGo({
                initialize: {
                    appId: DATAGO_ID,
                },
                transform: composeTransforms(defaultDataGoTransform, function () {
                    return defaultDataGoUserContextTransform({
                        userId: getCookie(process.env.REACT_APP_ANALYTICS_USER_IDENTITY_COOKIE_NAME),
                    });
                }),
            }),
    ].filter(function (plugin) { return !!plugin; }),
});
